import * as React from 'react';

const SplitBox24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M18.0001 3.25C20.0711 3.25006 21.7501 4.92897 21.7501 7V17C21.7501 19.071 20.0711 20.7499 18.0001 20.75H6.00012C3.92905 20.75 2.25012 19.0711 2.25012 17V7C2.25013 4.92894 3.92906 3.25 6.00012 3.25H18.0001ZM6.00012 4.75C4.75749 4.75 3.75013 5.75736 3.75012 7V17C3.75012 18.2426 4.75748 19.25 6.00012 19.25H8.25012V4.75H6.00012ZM9.75012 19.25H18.0001C19.2427 19.2499 20.2501 18.2426 20.2501 17V7C20.2501 5.7574 19.2427 4.75006 18.0001 4.75H9.75012V19.25Z'
				fill='#333333'
			/>
		</svg>
	);
};

export default SplitBox24;
